import React from 'react'
import { useCurrentUser } from './useCurrentUser'
import { config } from '../modules/app/config'
import { IntercomProvider as _IntercomProvider } from 'react-use-intercom'
import { IntercomProps } from 'react-use-intercom/dist/types'

interface IIntercomContext {
    open: () => void
}

export const IntercomContext = React.createContext<IIntercomContext | undefined>(undefined)

export const IntercomProvider = ({ children }) => {
    const { me, impersonator } = useCurrentUser()

    const autoBootProps: IntercomProps = {
        email: me.email,
        userId: me.id,
        createdAt: Math.round(new Date(me.createdAt).getTime() / 1000).toString(),
        name: `${me.firstName ?? ''} ${me.lastName ?? ''}`.trim(),
        phone: me.phone!,
        avatar: {
            type: 'avatar',
            imageUrl: me.picture!,
        },
    }

    const shouldBoot = me && !impersonator

    return (
        <_IntercomProvider
            autoBoot={shouldBoot}
            autoBootProps={autoBootProps}
            appId={config.intercomOrgId}
        >
            {children}
        </_IntercomProvider>
    )
}
